// src/components/ui/Pagination.tsx

import React from "react";

interface Props {
  page: number; // base 0
  totalPages: number;
  totalElements: number;
  size: number;
  onChange: (page: number) => void;
}

export default function Pagination({
  page,
  totalPages,
  totalElements,
  size,
  onChange,
}: Props) {
  if (totalElements === 0) return null;
  const from = page * size + 1;
  const to = Math.min((page + 1) * size, totalElements);

  return (
    <div className="pagination-bar">
      <span>
        Mostrando <strong>{from}</strong>–<strong>{to}</strong> de{" "}
        <strong>{totalElements}</strong>
      </span>
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn-tp-ghost"
          disabled={page === 0}
          onClick={() => onChange(page - 1)}
        >
          <i className="bi bi-chevron-left" /> Anterior
        </button>
        <span>
          Página {page + 1} de {Math.max(totalPages, 1)}
        </span>
        <button
          className="btn-tp-ghost"
          disabled={page >= totalPages - 1}
          onClick={() => onChange(page + 1)}
        >
          Siguiente <i className="bi bi-chevron-right" />
        </button>
      </div>
    </div>
  );
}
